import React from 'react';
import './index.less';
const AIMessage = ({ message, loading, t = (term) => term}) => {
    const i18n = typeof window.global_i18n === "function" ? window.global_i18n: t;
     return (
        <div className="message ai">
            <div className="inner_row">
                <span className="chat_name">
                    <div className="icon_wrap">
                        <span className="icon-svg-stars-01" />
                    </div>
                    {i18n('AI Support Agent')}
                </span>
            </div>
            <div className="message_content">
                <span className="message_text">
                    {loading && (
                        <div className="loader_wrapper">
                            <div className="loader">Loading...</div>
                        </div>
                    )}{' '}
                    {message}
                </span>
            </div>
        </div>
    );
};

export default AIMessage;
